export const ProductDetailPreview = () => {

  return (
    <>
      <h2 className="mb-8">
        Preview
      </h2>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat dolores eum quaerat aliquam neque animi, rem vel error! Odit inventore reprehenderit veniam veritatis cupiditate eaque ipsum saepe fuga ex debitis.
      </p>
    </>
  );
}